import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { PermissionsRuntimeState, RuntimeModulePermissions } from '../models/PermissionsState';

import { getRuntimePermissions } from '../../api/resource';

export const fetchRuntimePermissions = createAsyncThunk<
  Record<string, RuntimeModulePermissions>,
  void
>('permissionsRuntime/fetchRuntimePermissions', async (_, thunkApi) => {
  const response = await getRuntimePermissions(thunkApi.signal);

  /**
   * Убираем двойную вложенность:
   * modules.modules -> modules
   */

  return response?.modules ?? {};
});

const initialState: PermissionsRuntimeState = {
  modules: {},
  initialized: false,
  loading: false,
};

const permissionsRuntimeSlice = createSlice({
  name: 'permissionsRuntime',
  initialState,
  reducers: {
    clearRuntimePermissions(state) {
      state.modules = {};
      state.initialized = false;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRuntimePermissions.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchRuntimePermissions.fulfilled, (state, action) => {
      state.loading = false;
      state.initialized = true;
      state.modules = action.payload;
    });

    builder.addCase(fetchRuntimePermissions.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { clearRuntimePermissions } = permissionsRuntimeSlice.actions;

const PermissionsRuntimeReducer = permissionsRuntimeSlice.reducer;
export default PermissionsRuntimeReducer;
